<template>
	<div>
		<div class="form-inline">
			<v-icon @click="loadTags">mdi-label-multiple-outline</v-icon>
			<template v-for="tag in tags">
				<slot name="each" v-bind="{ tag }">
					<!-- <span id="tag"> -->
					<v-chip color="warning" class="mr-1 mb-1">{{ tag.name }}
						<v-btn text x-small v-if="deletable" @click="removeTag(tag.name)">
							<v-icon color="error" small>$delete</v-icon>
						</v-btn>
					</v-chip>
					<!-- </span> -->
				</slot>
			</template>
			<template v-if="updatable">
				<v-btn text x-small @click="addDlg = true">
					<v-icon small>$plus</v-icon>
				</v-btn>
			</template>
		</div>
		<v-dialog v-model="addDlg" class="d-block justify-center align-center">
			<v-card>
				<v-card-title>添加标签</v-card-title>
				<v-card-text>
					<v-text-field id="tags" type="text" v-model="newtags" value=" " class="d-inline-block mr-1"
						style="width:20rem" />
					<small class="form-text">
						多个标签之间用空格或者逗号(,)隔开
					</small>
				</v-card-text>
				<v-card-actions class=d-flex>
					<v-btn text @click="addDlg = false">
						<v-icon small>$close</v-icon>取消
					</v-btn>
					<v-btn color="primary" @click="updateTag">
						<v-icon small>$check</v-icon>确认添加
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>
<script>
export default {
	props: {
		id: { type: String },
		type: { type: String },
		deletable: { type: Boolean, default: false },
		updatable: { type: Boolean, default: false }
	},
	data() {
		return {
			tags: [],
			newtags: '',
			addDlg: false
		}
	},
	mounted() {
		this.loadTags();
	},
	methods: {
		loadTags() {
			this.$http.get('/tag/getByObject/' + this.type + '/' + this.id + '/', {
			}).then((response) => {
				this.tags = response
			}).catch((error) => {
				console.log(error);
			});
		},
		removeTag(tag) {
			this.$confirm('确定要删除标签 - ' + tag + '？').then(r => {
				if (!r) return
				this.$http.get('/tag/remove/' + this.type + '/' + this.id + '/' + tag + '/', {}).then((response) => {
					this.loadTags();
				}).catch((error) => {
					console.log(error);
				});
			})
		},
		updateTag() {
			this.$http.get('/tag/add/' + this.type + '/' + this.id + '/' + this.newtags + '/', {
			}).then((response) => {
				this.loadTags();
				this.newtags = '';
				alert('添加标签成功');
				this.addDlg = false;
			}).catch((error) => {
				console.log(error);
			});
		},
	}
}
</script>
